/**
 * Copyright © Redbox Digital Limited. All rights reserved.
 */
define('Magento_Catalog/js/product/list/catalog-header',[
    'jquery',
    'domReady!'
], function ($) {
    'use strict';
    return function (config, el) {
        var rdb = rdb || {}

        rdb.catalogHeader = {
            init: function () {
                var _self = this;
                this._moreLink();
                this._updateSimoLayout();
            },
            _moreLink: function () {
                $('.category-header-text a').on('click', function (event) {
                    event.preventDefault()
                    $('.category-header-text').addClass('show')
                })
            },
            _updateSimoLayout: function () {
                const body = $('body');
                if (body.hasClass('page-layout-category-simo')) {
                    body.addClass('filter-active');
                }
            }
        }
        rdb.catalogHeader.init();
    }
});

